module.exports = __webpack_public_path__ + "media/images/favicon-fb57fa84cbce8f06d945f7a82af6c3e3.svg";